var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 403,
    viewBox: "0 0 600 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.033 265.677L227.613 314.72C114.275 364.655 30.3165 358.44 0.890171 260.072C-5.11414 202.052 19.368 174.142 70.9528 150.774C86.9008 144.964 93.851 143.247 102.061 143.487L137.372 147.691C181.391 151.246 209.191 196.116 258.721 251.664L216.123 265.677L183.053 251.664V274.809C190.19 272.108 197.831 269.069 206.033 265.677Z",
    fill: "#2A214A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.913 254.467L223.689 152.456L266.848 228.964L318.975 220.277L308.605 284.734L353.165 370.211L266.848 357.599L250.033 403L225.091 358.72L127.563 357.599L204.913 254.467Z",
    fill: "#F3B29D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.033 265.677L227.613 314.72C114.275 364.655 30.3165 358.44 0.890171 260.072L69.2713 276.887C93.6976 295.432 116.158 299.401 177.483 276.887C179.305 276.218 181.161 275.525 183.053 274.809C190.19 272.108 197.831 269.069 206.033 265.677Z",
    fill: "#2A214A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235.74 217.194L240.224 228.685M308.886 311.078L324.58 318.365M277.498 315.002L275.816 325.371",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.428 250.264L270.211 241.576L286.185 289.499L250.874 302.951L239.664 296.785L234.059 282.212V267.92L244.428 250.264Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.313 249.983C233.75 248.037 224.341 252.38 207.435 265.677L206.594 266.238L227.052 314.16L241.065 304.352L270.491 293.422L270.5 293.418C274.126 291.773 276.162 290.849 273.854 286.416L259.281 282.772H273.854C276.455 281.508 277.419 280.607 275.816 277.728L261.523 271.562L276.937 275.486C279.206 273.414 279.513 272.117 276.937 269.32C272.055 265.777 268.584 264.024 261.523 261.193C259.349 260.08 257.799 260.386 254.517 262.314L243.867 277.728C241.509 278.973 240.306 279.164 239.103 275.486C239.063 269.515 239.701 266.033 243.867 259.231C251.106 258.748 254.669 257.832 259.281 253.907C257.65 250.916 255.45 250.241 250.313 249.983Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.263 306.594C240.701 299.471 242.814 296.098 248.912 292.021C248.804 298.814 247.507 302.532 244.428 309.116C241.657 310.271 240.166 310.554 238.263 306.594Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M246.95 303.231C249.389 296.109 251.501 292.736 257.6 288.658C257.491 295.452 256.195 299.17 253.116 305.753C250.345 306.909 248.853 307.192 246.95 303.231Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256.479 298.747C258.917 291.625 259.348 290.213 265.447 286.136C270.771 290.339 265.723 294.685 262.644 301.269C259.873 302.425 258.381 302.708 256.479 298.747Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.931 198.698H392.68L487.965 191.411V0H269.931V198.698Z",
    fill: "url(#paint0_linear_458_413)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M371.382 36.5169C372.708 18.9197 379.197 1.69618 400.283 6.38599C421.369 11.0758 409.53 10.8283 418.219 11.7109C426.909 12.5935 454.576 23.7179 454.091 40.5767C451.949 59.5667 431.031 65.4041 410.056 73.5106C410.056 73.5106 391.897 37.0078 386.515 33.4348C381.133 29.8619 370.721 42.2767 371.382 36.5169Z",
    fill: "#2A214A",
    stroke: "#2A214A",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M488.806 268.199L479.838 215.232C537.009 211.589 579.047 144.329 502.258 124.711L529.162 187.207L418.463 197.016L403.89 158.622C379.039 250.015 350.736 273.34 287.306 289.779L269.65 241.295C328.223 230.926 340.478 180.918 362.694 119.386C375.953 100.384 384.643 90.6423 409.215 79.8712L409.916 79.6273C427.965 73.3478 438.3 69.7525 463.303 68.6611C673.288 73.4985 605.39 263.996 488.806 268.199Z",
    fill: "#2A214A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440.603 251.665V167.59H519.073V173.755H531.684V225.602H519.073V251.665H440.603Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M519.073 173.755V167.59H440.603V251.665H519.073V225.602M519.073 173.755H531.684V225.602H519.073M519.073 173.755V225.602",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M453.214 189.729H495.532M453.214 205.143H480.959",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M488.806 268.199L479.838 215.232C537.009 211.589 579.046 144.329 502.258 124.711L463.303 68.6611C673.287 73.4985 605.39 263.996 488.806 268.199Z",
    fill: "#2A214A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M369.699 38.9487C370.497 31.7495 371.687 26.8411 375.672 17.1836C380.4 20.8385 393.024 23.0017 403.146 23.2294C413.827 23.4698 407.127 35.7242 403.146 38.9487L416.882 44.9945L442.564 77.6421L416.882 124.8L413.896 85.5017L391.2 53.4587C383.078 56.8444 377.464 46.4052 375.672 40.7624L369.699 38.9487Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M430.95 275.107C461.836 272.691 476.03 270.766 495.128 266.205L485.804 215.246C462.476 215.189 451.477 216.875 436 223.262C432.593 225.888 432.71 227.235 436.38 229.423C443.401 228.6 447.237 228.401 453.321 230.028C455.901 231.639 455.908 232.635 453.599 234.546C438.642 239.768 433.176 242.217 426.278 246.124C423.819 248.654 423.758 249.847 426.607 251.463L446.732 250.223C447.932 250.862 448.158 251.285 446.858 252.276L426.987 257.624C423.65 260.405 423.416 261.863 427.391 264.195L447.516 262.955C448.902 263.514 449.473 263.84 447.618 264.598C447.618 264.598 436.32 268.592 430.646 270.179C424.972 271.765 425.216 274.241 430.95 275.107Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M182.773 276.325C185.035 219.12 187.684 184.951 170.161 157.779C125.562 138.954 104.144 139.054 70.1119 151.614C76.3752 181.417 77.4265 197.43 61.1439 220.836C49.8148 251.593 52.723 263.17 70.1119 276.325C101.903 299.447 129.212 294.445 182.773 276.325Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.672 87.0966C153.375 77.8483 150.097 73.6018 142.183 68.2609L136.758 67.4817L119.646 73.7254L113.765 89.8877L114.418 104.615L108.686 144.53L102.874 143.695L122.616 174.216L138.305 147.597L132.879 146.818L139.772 109.839C149.31 106.012 152.505 102.226 153.073 91.5778C154.08 89.8534 154.901 88.8783 157.672 87.0966Z",
    fill: "white",
    stroke: "#2A214A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111.566 70.1799C104.679 83.2468 105.991 90.8689 111.985 101.744C113.35 104.221 116.623 105.032 118.778 103.201C120.59 101.662 122.036 99.936 123.423 97.3646C124.488 95.3888 123.74 92.9694 121.895 91.6903C121.141 91.1675 120.533 90.4441 120.248 89.5719C119.212 86.3992 119.955 84.728 123.889 83.6267C125.49 83.1785 126.775 81.9177 127.011 80.2717C127.182 79.0812 127.901 78.0397 128.953 77.4576L141.966 70.2612C142.76 69.8222 143.425 69.1725 143.868 68.3812C148.826 59.5331 148.571 56.4127 143.048 55.0131C142.453 54.8623 141.823 54.8591 141.219 54.9656C128.461 57.211 121.877 60.2953 112.551 68.9009C112.155 69.2656 111.817 69.7042 111.566 70.1799Z",
    fill: "#2A214A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_413",
    x1: 212.292,
    y1: -182.5,
    x2: 378.948,
    y2: 198.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B29D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.c7f25b92eee7727d1d5d9f4cc4432016.svg";
export { ForwardRef as ReactComponent };